<template>
    <section>
        <div id="trial" ref="trialRef" class="container">
            <div class="text-title">Free Trial</div>
            <div class="float-right gt-xs" :style="{ 'margin-top': productLine.name == 'LengthWise' ? '-55px' : 'auto' }">
                <img :src="require('@/assets/img/content/free-trial.png')" class="q-px-md">
            </div>
            <div v-if="productLine.name == 'LoopCAD'">
                <p>The free Trial Version allows you to try LoopCAD at no-obligation for 30 days. The Trial Version is fully functional, with the only difference the addition of a small "Trial Version" footnote on the reports and printed drawings.</p>
                <p>When you first install LoopCAD it will automatically be in Trial Version mode. You can choose to <router-link to="/support/help/purchase-cc">purchase a license</router-link> and activate your copy anytime during or after the trial period. The easy to use Activation Wizard will always be available to guide you through the process.</p>
                <p>To ensure that you have uninterrupted use of LoopCAD, it is recommended to start the activation process a few working days before the trial expiry. For more information view the <a href="#licenseInfo">License and Subscriptions</a> section below.</p>
                <p>Get your free Trial Version now by clicking the Download button. The OEM editions are also available to you for the free trial. Simply download and install the desired program edition.</p>

                <div class="row q-my-lg">
                    <q-btn label="Download Trial Now" icon="mdi-download" color="positive" class="col-xs-12 col-sm-auto"
                           to="/download/loopcad" />
                </div>
                <div class="text-caption">
                    Users of older versions of LoopCAD can install the LoopCAD {{ productLine.year }} Trial Version without affecting your existing installation(s). Both old and new versions can be used on the same computer at the same time.
                </div>
            </div>
            <div v-if="productLine.name == 'HeatCAD'">
                <p>The free Trial Version allows you to try HeatCAD at no-obligation for 30 days. The Trial Version is fully functional, with the only difference the addition of a small "Trial Version" footnote on the reports and printed drawings.</p>
                <p>When you first install HeatCAD it will automatically be in Trial Version mode. You can choose to <router-link to="/support/help/purchase-cc">purchase a license</router-link> and activate your copy anytime during or after the trial period. The easy to use Activation Wizard will always be available to guide you through the process.</p>
                <p>To ensure that you have uninterrupted use of HeatCAD, it is recommended to start the activation process a few working days before the trial expiry. For more information view the <a href="#licenseInfo">License and Subscriptions</a> section below.</p>
                <p>Get your free Trial Version now by clicking the Download button. (Note that this is also the download for the Full version - your activation code will determine the status).</p>
                <div class="row q-my-lg">
                    <q-btn label="Download Trial Now" icon="mdi-download" color="positive" class="col-xs-12 col-sm-auto"
                           to="/download/heatcad" />
                </div>
                <div class="text-caption">
                    Users of older versions of HeatCAD can install HeatCAD {{ productLine.year }} Trial Version without affecting your existing installation(s). Both old and new versions can be used on the same computer at the same time.
                </div>
            </div>
            <div v-if="productLine.name == 'PlumbingCAD'">
                <p>The free Trial Version allows you to try PlumbingCAD at no-obligation for 30 days. The Trial Version is fully functional, with the only difference the addition of small "Trial Version" footnotes on the reports and printed drawings</p>
                <p>When you first install PlumbingCAD it will automatically be in Trial Version mode. You can choose to <router-link to="/support/help/purchase-cc">purchase a license</router-link> and activate your copy any time during or after the trial period. The easy-to-use Activation Wizard will always be available to walk you through the process.</p>
                <p>To ensure that you have uninterrupted use of PlumbingCAD, it is recommended that you start the activation process a few working days before the trial expiry. For more information view the <a href="#licenseInfo">License and Subscriptions</a> section below.</p>
                <p>Get your free Trial Version now by clicking the Download button.</p>

                <div class="row q-mt-lg">
                    <q-btn label="Download Trial Now" icon="mdi-download" color="positive" class="col-xs-12 col-sm-auto"
                           to="/download/plumbingcad" />
                </div>
            </div>
            <div v-if="productLine.name == 'LengthWise'">
                <p>The free Trial Version of LengthWise allows you to try its great new features, at no-obligation, for up to 30 days.</p>
                <p>Get your free Trial Version now by clicking the Download button.</p>

                <div class="row q-mt-lg">
                    <q-btn label="Download Trial Now" icon="mdi-download" color="positive" class="col-xs-12 col-sm-auto"
                           to="/download/lengthwise" />
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'free-trial',
        props: {
            productLine: Object,
        },
        mounted() {
            if (this.$route.hash == '#trial')
                setTimeout(() => {
                    this.scrollToElement(this.$refs.trialRef)
                }, 100)

        }
    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 55px;
        }
    }
</style>
